
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import ReactToPrint from 'react-to-print';
import HeaderInvoice from '../bookings/invoice/HeaderInvoice';
import { View_state, View_verification } from '../functions/data_view';
import { deletecustomer, getcustomers } from '../Helper/links';
import pattern from "../Helper/pattern";
import API from "../Helper/server/API";
import logo from '../public/images/logo.png';
import CustomerEditComponet from "./CustomerEditComponet";
import CustomerShowComponet from "./CustomerShowComponet";
import { View_whatsapp_number } from '../constants/dataView';
import { Skeleton } from 'primereact/skeleton';

function Customers() {
    const Navigate = useNavigate();
    const toast = useRef(null);
    const componentRef = useRef();
    const buttonRef = useRef();
    const items = Array.from({ length: 19 }, (v, i) => i);
    const [isShown, setIsShown] = useState(false);
    const [show_customer, set_show_customer] = useState(false);
    const [show_edit, set_show_edit] = useState(false);
    const [show_delete, set_show_delete] = useState(false);
    const [name_phone, setname_phone] = useState("");
    const [loading_customers, set_loading_customers] = useState(false);
    const [customers, set_customers] = useState([]);
    const [customer_show, set_customer_show] = useState({});
    const footerContent = (
        <center dir="ltr">
            <Button label="تاكيــد الحــذف" icon="pi pi-check ml-2" severity="danger mr-2" outlined onClick={() => {
                set_show_delete(false)
                DeleteCustomer()
            }} />
            <Button label="إلغــاء" icon="pi pi-times ml-2" onClick={() => set_show_delete(false)} outlined autoFocus />
        </center>
    );
    const [customers_view, set_customers_view] = useState([]);
    const clearFilter = () => {
        setname_phone("");
        GetCustomers();
    };
    const handel_name_phone = (e) => {
        setname_phone(e.target.value)
    }
    const renderHeader = () => {
        return (
            <div className="col-md-12">
                <div className="row">
                    <div className="col-md-11">
                        <div className="flex justify-content-between" style={{ fontFamily: "Cairo", fontSize: "15px" }} dir="rtl">
                            <InputText
                                value={name_phone}
                                onChange={(e) => handel_name_phone(e)}
                                placeholder="الأسم أو رقم الهاتف"
                                className="col-md-4"
                                style={{ fontFamily: "Cairo", fontSize: "15px", width: "100%" }}
                            />
                            <Button
                                dir="ltr"
                                type="button"
                                icon="fa fa-remove"
                                outlined
                                severity="danger"
                                onClick={clearFilter}
                                style={{ marginRight: "0px" }}
                            />
                            <Button
                                dir="ltr"
                                type="button"
                                icon="fa fa-search"
                                outlined
                                onClick={search}
                                style={{ marginRight: "5px" }}
                            />
                            <p style={{ fontSize: "18px" }} className="mt-2"> {customers_view && customers_view.length >= 0 ? customers_view.length + " عميل" : null}</p>
                        </div>
                    </div>
                    <div className="col-md-1" style={{ textAlign: "left", fontFamily: "Cairo" }}>
                        <Button icon="fa fa-refresh" rounded outlined onClick={GetCustomers} />
                    </div>
                </div>
            </div>
        );
    };
    const search = (e) => {
        e.preventDefault();
        //___________________________________________________________________
        //                  Search
        var resulte = []
        // eslint-disable-next-line array-callback-return
        customers.map((customer) => {
            if (
                !name_phone || name_phone.toString().trim() === "" ||
                (
                    (customer.visitor_name != null && (customer.visitor_name.toString().startsWith(name_phone.toString())
                        || customer.visitor_name.toString().endsWith(name_phone.toString())))
                    //_____________________________________________
                    || (customer.phone_number != null && (customer.phone_number.toString().startsWith(name_phone.toString())
                        || customer.phone_number.toString().endsWith(name_phone.toString())))
                    //_____________________________________________
                    || (customer.whatsapp_number != null && (customer.whatsapp_number.toString().startsWith(name_phone.toString())
                        || customer.whatsapp_number.toString().endsWith(name_phone.toString())))
                )
            ) {
                resulte.push(customer);
            }
        })
        set_customers_view(resulte);
    };
    //                      Get Customers
    const GetCustomers = async () => {
        set_loading_customers(true);
        const response = await API.get(`${getcustomers}?del=0`);
        if (response?.success) {
            set_customers(response.data);
            set_customers_view(response.data);
        }
        set_loading_customers(false);
    }
    const View_user = (item) => {
        if (item.id_user) {
            return (
                <img src={logo} alt={item.visitor_name} style={{ width: "30%" }} ></img>
            )
        }
        else {
            return (
                <>-</>
            )
        }
    }
    const View_note = (item) => {
        return (
            <p style={{ fontSize: "13px" }}>
                {item.note}
            </p>
        )
    }

    const View_Button = (item) => {
        return (
            <>
                <Button
                    type="button"
                    icon="pi pi-external-link"
                    severity="secondary"
                    text
                    onClick={(e) => {
                        set_customer_show(item)
                        set_show_customer(true)
                    }}
                />
                <Button
                    type="button"
                    icon="fa fa-edit"
                    text
                    onClick={(e) => {
                        set_customer_show(item)
                        set_show_edit(true)
                    }}
                />
                <Button
                    type="button"
                    icon="fa fa-trash"
                    text
                    severity="danger"
                    onClick={(e) => {
                        set_customer_show(item)
                        set_show_delete(true)
                    }}
                />
            </>
        )
    }

    const DeleteCustomer = async () => {
        set_loading_customers(true);
        var validtion = true
        //_______________________________________________________________________________________
        //                         Validtion
        if (!customer_show || !customer_show?.ID_customer || (pattern.number_int.test(customer_show.ID_customer) === false)) {
            validtion = false
            document.getElementById("lvisitor_name").style.color = 'red';
        }
        if (!validtion) {
            toast.current.show({
                style: {
                    fontFamily: "Cairo",
                    fontSize: "1.1rem"
                },
                life: 3000,
                severity: 'error', summary: 'خطــاء', detail: "أرجــو إدخــال أختيــار العميــل"
            });
        }
        else {
            var data = {
                id_customer: customer_show.ID_customer
            }
            const response = await API.post(deletecustomer, data)
            if (response?.success) {
                set_customers(customers.filter(client => client.ID_customer !== customer_show.ID_customer));
                set_customers_view(customers.filter(client => client.ID_customer !== customer_show.ID_customer));
                set_customer_show({})
                toast.current.show({
                    style: {
                        fontSize: "1.2rem",
                        fontFamily: "Cairo"
                    },
                    life: 3000,
                    severity: 'success', summary: ' نجــاح ', detail: response?.msg
                });

            }
            else if (response?.success === 0) {
                toast.current.show({
                    style: {
                        fontFamily: "Cairo",
                        fontSize: "1.2rem"
                    },
                    life: 3000,
                    severity: 'error', summary: 'خطــاء', detail: response?.msg
                });
            }
        }
        set_loading_customers(false);
    }
    useEffect(() => {
        GetCustomers()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const scrollStyle = {
        overflowY: "auto",
        scrollbarWidth: "thin", // للمتصفحات غير Chrome
    };
    const scrollBarCSS = `
    ::-webkit-scrollbar {
            display: block !important;
            width: 5px;
            height: 8px;
    }
    `;
    return (
        <div className="page-wrapper" dir="rtl" >
            <div className="content-wrapper">
                <Toast ref={toast} position="top-center" style={{ margin: "0 1rem 0 0 !important", fontFamily: "Cairo" }} remove />
                <div className="page-heading">
                    <h1 className="page-title"> العملاء </h1>
                </div>
                <div className="card p-2">
                    <style>{scrollBarCSS}</style>
                    {
                        loading_customers ?

                            <DataTable value={items}
                                header={renderHeader}
                                className="p-datatable-striped"
                                tableStyle={{ minWidth: '50rem' }} style={{ fontFamily: "Cairo", direction: "rtl" }}>
                                <Column field="ID_customer" header="#" sortable style={{ textAlign: "right" }} body={<Skeleton />}></Column>
                                <Column field="visitor_name" header="الاسم" sortable style={{ textAlign: "right" }} body={<Skeleton />}></Column>
                                <Column field="phone_number" header="رقم الهاتف" style={{ textAlign: "right" }} body={<Skeleton />}></Column>
                                <Column field="whatsapp_number" header="رقم الواتساب" style={{ textAlign: "right" }} body={<Skeleton />}></Column>
                                <Column field="national_number" header="رقم الوطني" sortable style={{ textAlign: "right" }} body={<Skeleton />}></Column>
                                <Column field="note" header="ملاحظات" style={{ textAlign: "right", width: "20%" }} body={<Skeleton />}></Column>
                                <Column field="dentity_document" header="إثبات الهويــة" sortable style={{ textAlign: "right", minWidth: '15rem' }} body={<Skeleton />}></Column>
                                <Column field="id_user" header="التطبيق" sortable style={{ textAlign: "center", width: "10%" }} body={<Skeleton />}></Column>
                                {/* <Column field="date_create" body={View_date_create}  header="تـاريخ الإضـافة"  style={{ textAlign:"right",width:"10%" }} ></Column> */}
                                <Column field="state" header="حالتة" sortable style={{ textAlign: "right" }} body={<Skeleton />}></Column>
                                <Column field="ID_customer" header="أجراء" style={{ textAlign: "right", width: "10%" }} body={<Skeleton />}></Column>
                            </DataTable>
                            :
                            <DataTable value={customers_view} stripedRows
                                header={renderHeader} selectionMode="multiple"
                                paginator rows={10} rowsPerPageOptions={[10, 20, 30, 50, 100]}
                                paginatorClassName={<i className="pi pi-angle-right"  ></i>}
                                emptyMessage={<center><h4>لا يوجد عملاء</h4></center>}
                                scrollable scrollHeight="850px"
                                tableStyle={scrollStyle}
                                style={{ fontFamily: "Cairo", direction: "rtl", fontSize: "15px", border: "10px" }}
                            >
                                <Column field="ID_customer" header="#" sortable style={{ textAlign: "right" }}></Column>
                                <Column field="visitor_name" header="الاسم" sortable style={{ textAlign: "right" }}></Column>
                                <Column field="phone_number" header="رقم الهاتف" style={{ textAlign: "right" }}></Column>
                                <Column field="whatsapp_number" header="رقم الواتساب" body={View_whatsapp_number} style={{ textAlign: "right" }}></Column>
                                <Column field="national_number" header="رقم الوطني" sortable style={{ textAlign: "right" }}></Column>
                                <Column field="note" header="ملاحظات" body={View_note} style={{ textAlign: "right", width: "20%" }}></Column>
                                <Column field="dentity_document" body={View_verification} header="إثبات الهويــة" sortable style={{ textAlign: "right", minWidth: '15rem' }}></Column>
                                <Column field="id_user" body={View_user} header="التطبيق" sortable style={{ textAlign: "center", width: "10%" }}></Column>
                                {/* <Column field="date_create" body={View_date_create}  header="تـاريخ الإضـافة"  style={{ textAlign:"right",width:"10%" }} ></Column> */}
                                <Column field="state" body={View_state} header="حالتة" sortable style={{ textAlign: "right" }}></Column>
                                <Column field="ID_customer" body={View_Button} header="أجراء" style={{ textAlign: "right", width: "10%" }} ></Column>
                            </DataTable>
                    }
                </div>

                <Dialog dir="rtl" header="عــرض العميـــل" visible={show_customer} maximizable style={{ width: '70vw', fontFamily: "Cairo" }} onHide={() => set_show_customer(false)} maximized={window.innerWidth <= 1230 ? true : false} footer={<center >
                    <Button label="إغـــلاق" severity="danger" outlined icon="pi pi-times ml-2" onClick={(e) => set_show_customer(false)} />
                    <ReactToPrint
                        trigger={
                            () => <Button type="button" label="طبــاعة" icon='fa fa-print  ml-2' outlined className='mr-2'
                                ref={buttonRef} onClick={() => setIsShown(current => !current)}
                            />
                        }
                        content={() => componentRef.current}
                    />
                </center>}>

                    <div ref={componentRef} dir='rtl' style={{ padding: "2px" }}>
                        <br></br>
                        <HeaderInvoice title="ملـــف العميــل" style={{ paddingTop: "2px" }}></HeaderInvoice>
                        <CustomerShowComponet toast={toast} customer={customer_show}  ></CustomerShowComponet>
                    </div>
                </Dialog>
                <Dialog dir="rtl" header="تعــديل العميـــل" visible={show_edit} maximizable style={{ width: '70vw', fontFamily: "Cairo" }} onHide={() => set_show_edit(false)} maximized={window.innerWidth <= 1230 ? true : false}>
                    <CustomerEditComponet toast={toast} GetCustomers={GetCustomers} set_show_edit={set_show_edit} customer={customer_show} ></CustomerEditComponet>
                </Dialog>
                <Dialog header={"حــذف العميـــل ( " + customer_show?.visitor_name + " )"} visible={show_delete} style={{ minWidth: '30vw', fontFamily: "Cairo" }} onHide={() => { set_customer_show(null); set_show_delete(false) }} footer={footerContent} draggable={false} resizable={false}>
                    <hr></hr>
                    <h6 className="m-0">
                        هل أنت متأكد أنك تريد حذف العميل ؟ لا يمكن التراجع عن هذه العملية ؟
                    </h6>
                </Dialog>
            </div>
        </div>
    )
}

export default Customers


